import { render, staticRenderFns } from "./CalculatedMetrics.vue?vue&type=template&id=77f7fb1f&scoped=true"
import script from "./CalculatedMetrics.vue?vue&type=script&lang=ts"
export * from "./CalculatedMetrics.vue?vue&type=script&lang=ts"
import style0 from "./CalculatedMetrics.vue?vue&type=style&index=0&id=77f7fb1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f7fb1f",
  null
  
)

export default component.exports